import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../utils/useAuth";

export default function ProtectedRoute() 
{
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center bg-light vh-100 w-100">
        <div
          className="spinner-border text-green mb-3"
          style={{ width: "8rem", height: "8rem" }}
        ></div>
        <p className="text-secondary">Chargement en cours...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace state={{ message: "Votre session a probablement expiré. Merci de vous reconnecter pour accéder au service de commande." }} />;
  }

  return <Outlet />;
}
